import 'whatwg-fetch'
const gatewayService = process.env.GATEWAY_SERVICE_URL

export const parseJSON = (response) => {
  return response.text().then(function (text) {
    return text ? JSON.parse(text) : {}
  })
}

const api = async (endpoint, options) => {
  const defaultHeaders = options.isFile
    ? options.headers
    : {
        'Content-Type': 'application/json',
      } //workaround
  const defaults = {
    headers: defaultHeaders,
    body: options.isFile
      ? options.payload && options.payload
      : options.payload && JSON.stringify(options.payload),
    credentials: 'include',
  }
  const response = await window.fetch(`${gatewayService}${endpoint}`, {
    ...options,
    ...defaults,
    headers: { ...options.headers, ...defaults.headers }, //this is broken, doesnt work as intended for file upload
  })
  if (response.status >= 200 && response.status < 300) {
    if (options.responseType === 'blob') return response.blob()
    return parseJSON(response)
  } else {
    const error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

export default api
